import { render, staticRenderFns } from "./servetype-add-or-update.vue?vue&type=template&id=9b00e7f0&"
import script from "./servetype-add-or-update.vue?vue&type=script&lang=js&"
export * from "./servetype-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports